import React from "react";
import { ChevronLeft } from "@carbon/icons-react";

const FieldItem = ({ label, value, isFullWidth = false }) => (
  <div className={isFullWidth ? "uk-width-1-1" : ""}>
    <div className="uk-margin">
      <label
        className="uk-form-label"
        style={{
          fontSize: "11px",
          color: "#999",
          textTransform: "uppercase",
          fontWeight: "600",
          letterSpacing: "0.5px",
          marginBottom: "8px",
          display: "block",
        }}
      >
        {label}
      </label>
      <p
        style={{
          fontSize: "15px",
          color: "#333",
          fontWeight: "500",
          margin: "0",
          lineHeight: "1.6",
        }}
      >
        {value || "-"}
      </p>
    </div>
  </div>
);

const CampaignResponseDetail = ({ response, onBack }) => {
  const formatAnswer = (answer) => {
    if (Array.isArray(answer)) {
      return answer.join(", ");
    }
    return answer?.toString() || "-";
  };

  return (

    <div className="dashboardWrp">
    <div className="uk-container">
      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-1">
          <div className="uk-margin-medium-bottom">
            <button
              className="uk-button uk-button-secondary back-btn"
              onClick={onBack}
              // style={{
              //   display: "flex",
              //   alignItems: "center",
              //   gap: "6px",
              //   padding: "8px 16px",
              //   borderRadius: "4px",
              //   backgroundColor: "#f8f8f8",
              //   border: "1px solid #e5e5e5",
              //   color: "#666",
              //   fontWeight: "500",
              //   fontSize: "14px",
              // }}
            >
              <ChevronLeft size={18} />
              Back to Responses
            </button>
          </div>

          <div
            className="uk-card uk-card-default"
            style={{
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              borderRadius: "8px",
              border: "1px solid #e5e5e5",
            }}
          >
            <div
              className="uk-card-header"
              style={{
                backgroundColor: "#fafafa",
                borderBottom: "2px solid #e5e5e5",
                padding: "24px 32px",
              }}
            >
              <h3
                className="uk-card-title uk-margin-remove"
                style={{
                  fontSize: "22px",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Survey Response Details
              </h3>
            </div>

            <div className="uk-card-body" style={{ padding: "32px" }}>
              {/* Customer Information Section */}
              <div style={{ marginBottom: "32px" }}>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "20px",
                    paddingBottom: "10px",
                    borderBottom: "2px solid #e5e5e5",
                  }}
                >
                  Customer Information
                </h4>
                <div
                  className="uk-grid uk-grid-medium uk-child-width-1-2@m"
                  uk-grid=""
                  style={{ marginTop: "0" }}
                >
                  <FieldItem
                    label="Customer Email"
                    value={response?.customerId?.email}
                  />
                  <FieldItem
                    label="Customer Phone"
                    value={response?.customerId?.phone}
                  />
                  <FieldItem
                    label="Order Number"
                    value={response?.orderId?.orderNo}
                  />
                  <div>
                    <div className="uk-margin">
                      <label
                        className="uk-form-label"
                        style={{
                          fontSize: "11px",
                          color: "#999",
                          textTransform: "uppercase",
                          fontWeight: "600",
                          letterSpacing: "0.5px",
                          marginBottom: "8px",
                          display: "block",
                        }}
                      >
                        Status
                      </label>
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 14px",
                          borderRadius: "16px",
                          fontSize: "12px",
                          fontWeight: "600",
                          textTransform: "capitalize",
                          backgroundColor: response.isCompleted
                            ? "#32d296"
                            : "rgb(240 154 30)",
                          color: "#fff",
                        }}
                      >
                        {response.isCompleted ? "Completed" : "Incomplete"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Survey Answers Section */}
              <div style={{ marginBottom: "32px" }}>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "20px",
                    paddingBottom: "10px",
                    borderBottom: "2px solid #e5e5e5",
                  }}
                >
                  Survey Responses
                </h4>
                <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
                  {response?.answers?.map((answer, index) => (
                    <div
                      key={answer._id}
                      style={{
                        padding: "20px",
                        backgroundColor: "#fafafa",
                        borderRadius: "8px",
                        border: "1px solid #e5e5e5",
                      }}
                    >
                      <div style={{ marginBottom: "12px" }}>
                        <label
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#666",
                            display: "block",
                            marginBottom: "8px",
                          }}
                        >
                          {answer?.questionText ? answer?.questionText : "Question " + (index + 1)}
                        </label>
                        <p
                          style={{
                            fontSize: "15px",
                            color: "#333",
                            fontWeight: "500",
                            margin: "0",
                            lineHeight: "1.6",
                            wordBreak: "break-word",
                          }}
                        >
                          {formatAnswer(answer.answer)}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Additional Information Section */}
              {/* <div>
                <h4
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "20px",
                    paddingBottom: "10px",
                    borderBottom: "2px solid #e5e5e5",
                  }}
                >
                  Additional Information
                </h4>
                <div
                  className="uk-grid uk-grid-medium uk-child-width-1-2@m"
                  uk-grid=""
                  style={{ marginTop: "0" }}
                >
                  <FieldItem
                    label="IP Address"
                    value={response?.ipAddress}
                  />
                  <FieldItem
                    label="Overall Rating"
                    value={response?.overallRating}
                  />
                  <FieldItem
                    label="Submitted At"
                    value={
                      response.submittedAt
                        ? new Date(response.submittedAt).toLocaleString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : "-"
                    }
                    isFullWidth={true}
                  />
                  <FieldItem
                    label="Created At"
                    value={
                      response.createdAt
                        ? new Date(response.createdAt).toLocaleString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : "-"
                    }
                    isFullWidth={true}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default CampaignResponseDetail;
